export const UNAUTHORISED_ACCESS = 'Unauthorised Access';
export const CONTACT_TECH_SUPPORT =
  'Please contact Tech Support for login access';
